
import React from "react";
import { Row, Col } from "react-bootstrap";
import isEqual from "is-equal";
import { guid } from "src/services/util";
import { InputWithIcon } from "src/components/input";
import SkillListDetailView from "../components/ListSkills/skillListDetailView";

import _ from "lodash";
import cx from "classnames";
import styles from "./SkillDetailsView.module.scss";

class SkillDetailView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      skills: [],
    };

    this.handleChangeOption = this.handleChangeOption.bind(this);
    this.handleDeleteOption = this.handleDeleteOption.bind(this);
    this._handleAddValueClick = this._handleAddValueClick.bind(this);
  }

  _handleAddValueClick = () => {
    const skills = [
      {
        id: guid(),
        name: "Untitled",
        isNew: true
      },
      ...(this.state.skills || [])
    ];

    this.setState({
      skills: skills,
      selection: {
        ...this.state.selection,
        subSkills: skills
      }
    });

    this.props.onFieldChange("subSkills", skills);
  };



  componentDidMount() {
    if (this.props.item.children) {
      this.setState({
        skills: this.props.item.children,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
  const newSkills = nextProps.item.subSkills || nextProps.item.children || [];

  if (!isEqual(newSkills, this.state.skills)) {
    this.setState({
      skills: newSkills,
    });
  }
  }

  handleDeleteOption(skill) {
    let skills = this.state.skills.filter((item) => item.id !== skill.id);

    this.setState({
      skills: skills,
    });
    this.props.onFieldChange("subSkills", skills);
  }

  handleChangeOption(skill, value) {
    let updatedSkills = this.state.skills.map((item) =>
      item.id === skill.id ? { ...item, ...skill, name: value } : item
    );
    this.setState({
      skills: updatedSkills,
      selection: {
        ...this.state.selection,
        subSkills: updatedSkills
      }
    });

    this.props.onFieldChange("subSkills", updatedSkills);
  }

  _handleChange(field, e) {
    var value = e.target.value;
    this.props.onFieldChange(field, value);
  }

  render() {
    return (
      <div className={styles.content}>
        <h4 className={styles.heading}>
          {this.props.creating
            ? "Create Skill"
            : "Update Skill"}
        </h4>
        <Row className={cx(styles.row)}>
          <Col md={12} lg={12} xl={12}>
            <InputWithIcon
              value={this.props.item.name}
              onChange={this._handleChange.bind(this, "name")}
              placeholder={
                "Skills name"
              }
            />
            <span className={styles.error}>{this.props.errors?.parentSkill && this.props.errors?.parentSkill || ""}</span>

          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className={styles.listOptionsContainer}>
              <div className={styles.label}>
                SubSkills:
              </div>
              <div
                className={cx(styles.action, styles.add)}
                onClick={this._handleAddValueClick}
              >
                <i className="paperflite-add" />
                <span>ADD SUBSKILL</span>
              </div>

              <div className={cx(styles.sectionsList)}>
                <div>
                  {this.renderItems()}
                </div>
              </div>
              <span className={styles.error}>
                {this.props.errors?.subSkill && this.props.errors?.subSkill || ""}
              </span>
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  renderItems() {
    return this.state.skills.map((child, index) => {
      return (
        <div key={index}>
          <SkillListDetailView
            key={index}
            index={index}
            option={child}
            onChange={this.handleChangeOption}
            onDelete={this.handleDeleteOption}
          />
          <div className={styles.line} />
        </div>
      );
    });
  }
}

export default SkillDetailView;

